import pattern from '../../../pattern.svg';

import { useState, useEffect, useRef } from 'react';

import { useStep } from '../../Base/StepContext';
import { useGlobal } from '../../../Core/GlobalState/Store';
import LoadingSpinner from '../../ReusableComponents/LoadingSpinner';
import MapService from '../../../Core/Services/MapService';

import ContainerSelectionBody from './Body/ContainerSelectionBody';
import ContainerSizeSelectorHeader from './Headers/ContainerSizeSelectorHeader';

export default function ContainerSizeSelect() {
  const { handleNext } = useStep();

  const [roomList, setRoomList] = useState([]);
  const [siteMap, setSiteMapData] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(0);
  const {
    currentLocation: location,
    pluginUrl,
    loading,
    setLoading,
    sizeTypes,
    setSizeTypes,
    selectedSize,
    setSelectedSize,
    setRoom,
  } = useGlobal();

  useEffect(() => {
    let isMounted = true;
    // IIFE cause react hook cannot be async directly
    (async () => {
      try {
        setLoading(true);
        // You need to have a location selected to fe
        // tch the map data, you should never reach this point without a location
        if (!location || !location.id) {
          setLoading(false);
          return;
        }

        const response = await MapService.fetchMapDataByLocationId(location.id);

        if (!response || !response.mapData) {
          if (isMounted) {
            setSiteMapData(null);
            setRoomList([]);
          }
          return;
        }

        try {
          const parsed = JSON.parse(response.mapData);
          if (isMounted) {
            setSiteMapData(parsed);
            setRoomList(MapService.generateAvailableRoomList(parsed));
          }
        } catch (e) {
          if (isMounted) {
            setSiteMapData(null);
            setLoading(false);
            setRoomList([]);
          }
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [location]);

  useEffect(() => {
    if (!siteMap) return;
    try {
      const newSizeTypes = MapService.addFromPriceAndAvailableAmountToSizeTypes(
        siteMap,
        sizeTypes
      );
      setSizeTypes(newSizeTypes);
    } catch (e) {}
  }, [siteMap]);

  return (
    <div
      className="w-full flex flex-col !border-solid !border-l !border-r border-gray-300 border-1"
      style={{
        backgroundImage: `url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }}
    >
      <ContainerSizeSelectorHeader />

      {loading && (
        <div className="flex justify-center items-center h-[400px]">
          <LoadingSpinner />
        </div>
      )}

      {!loading && (
        <ContainerSelectionBody
          sizeTypes={sizeTypes}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          showPlacementBody={false}
          setShowPlacementBody={() => {}}
          roomList={roomList}
          handleNext={handleNext}
        />
      )}
    </div>
  );
}
